import { useCallback, useMemo } from 'react';
import { useWatch } from 'react-hook-form';

import { useMedicalProfileFormContext } from '../../MedicalProfileFormContext';
import { SectionNodeViewModel } from '../../tab/MedicalProfileTab.types';
import { createEntryKeysFieldName } from '../../tab/MedicalProfileTab.utils';

import { addEntry, readEntryKeys, removeEntry } from './EntryList.utils';

type EntryListState = {
   readonly entryKeys: string[];
   readonly handleAdd: VoidFunction;
   readonly handleRemove: (entryKey: string) => void;
};

export const useEntryList = (templateCode: string, node: SectionNodeViewModel): EntryListState => {
   const { control } = useMedicalProfileFormContext();
   const entryKeysFieldName = useMemo(() => createEntryKeysFieldName(templateCode, node.sectionId), [
      templateCode,
      node.sectionId,
   ]);
   const entryKeys = useWatch<string[]>({
      name: entryKeysFieldName,
      control: control,
      defaultValue: readEntryKeys(control, entryKeysFieldName),
   });

   const handleAdd = useCallback((): void => addEntry(control, templateCode, node), [control, templateCode, node]);

   const handleRemove = useCallback((entryKey: string): void => removeEntry(control, templateCode, node, entryKey), [
      control,
      templateCode,
      node,
   ]);

   return { entryKeys: entryKeys, handleAdd: handleAdd, handleRemove: handleRemove };
};
